<div
  [attr.data-automation-id]="automationId"
  class="timeline-item-contents position-relative mt-n9"
>
  <div
    class="timeline-item-icon float-start mt-4 ms-4 fill-white stroke-white icon-size-medium"
  >
    <digital-platform-svg-icon
      [iconSize]="itemIconSize"
      [svgIconClass]="itemIcon"
    >
    </digital-platform-svg-icon>
  </div>
  <div class="timeline-item-text me-4 ms-11 pt-4 text-white">
    <digital-platform-rsx-rich-text
      [body]="itemText ?? ''"
    ></digital-platform-rsx-rich-text>
  </div>
</div>
